import React from "react";
import MUIDivider, { DividerProps } from "@material-ui/core/Divider";

const Divider = (props: DividerProps) => {
	return <MUIDivider {...props} />;
};

export { Divider };
